
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/digital-strategy",
      function () {
        return require("private-next-pages/services/digital-strategy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/digital-strategy"])
      });
    }
  